module.exports = __webpack_public_path__ + "img/footer_icon.124d4c4b.svg";